<script lang="ts">
	import { onMount } from 'svelte';

	// Screen-recorded app demo: autoplays muted on a loop, but respects
	// Reduce Motion by holding on the first frame instead.
	let {
		src,
		label,
		width,
		height,
		class: klass = ''
	}: { src: string; label: string; width?: number; height?: number; class?: string } = $props();

	let video: HTMLVideoElement;

	onMount(() => {
		if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) {
			video.autoplay = false;
			video.pause();
			video.currentTime = 0;
		}
	});
</script>

<video
	bind:this={video}
	{src}
	{width}
	{height}
	autoplay
	loop
	muted
	playsinline
	preload="metadata"
	aria-label={label}
	class={klass}
></video>
